import axios from "axios";
import idAuthHeader from "../auth-header";
const API_URL = process.env.REACT_APP_API_URL + "api/core-schedules";

class corescheduleService {
  async uploadCoreSchedule(data) {
    return axios.post(API_URL, data, { headers: await idAuthHeader() });
  }
}

const coreScheduleService = new corescheduleService();
export default coreScheduleService;
